//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server } from "@/services/constants";
import Swal from "sweetalert2";
import pdfQuotationGenerator from "@/utils/pdfQuotationGenerator";
import PdfPreviewDialog from "@/components/cards/PdfPreviewDialog";

export default {
    name: "QuotationView",
    components: { PdfPreviewDialog },
    data() {
        return {
            currency_list: [],
            showVatDetailDialog: false,
            pdfBlob: null,
            pdfObj: null,
            dialogPDF: false,
            print_header_list: [
                {
                    id: "1", // ตรงกับ <v-radio value="1"> (DEJ-UDOM & ASSOCIATES LIMITED)
                    com_title: "STATEMENT",
                    com_name: "",
                    inv_company_name_th: "",
                    inv_company_address: "",
                    inv_company_branch: "",
                    inv_company_tel: "",
                    inv_company_email: "",
                    inv_tax_id: "",
                    com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
                    com_eng_2: "ATTORNEYS AT LAW",
                    com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                    com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                    com_add_no: "942/69 RAMA IV ROAD,",
                    com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
                    com_add_country: "BANGKOK 10500, THAILAND",
                    com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
                    com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
                    com_add_email: "E-MAIL : account@dejudom.com",
                    com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
                    // ✅ เพิ่ม: ชื่อบริษัทแบบ Title Case ไว้ใช้แทรกในข้อความ Quotation Terms
                    // ให้ตรงกับหัวเอกสารที่เลือกจริง (ต้องมี "Ltd." ต่อท้ายสำหรับบริษัทนี้)
                    com_display_name: "Dej-Udom & Associates Ltd.",
                    customer_paymentterm: "0",
                    credit_term_date: "",
                },
                {
                    id: "3", // ตรงกับ <v-radio value="3"> (สำนักงานกฎหมาย เดชอุดม แอนด์แอสโซซิเอทส์)
                    com_title: "STATEMENT",
                    com_name: "",
                    inv_company_name_th: "",
                    inv_company_address: "",
                    inv_company_branch: "",
                    inv_company_tel: "",
                    inv_company_email: "",
                    inv_tax_id: "",
                    com_eng_1: "DEJ-UDOM & ASSOCIATES",
                    com_eng_2: "ATTORNEYS AT LAW",
                    com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
                    com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                    com_add_no: "942/69 RAMA IV ROAD,",
                    com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
                    com_add_country: "BANGKOK 10500, THAILAND",
                    com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
                    com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
                    com_add_email: "E-MAIL : account@dejudom.com",
                    com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
                    // ✅ เพิ่ม: สำนักงานนี้ไม่มี "Ltd." ต่อท้าย ต้องตรงกับหัวเอกสาร (com_eng_1 ด้านบน)
                    com_display_name: "Dej-Udom & Associates",
                    customer_paymentterm: "0",
                    credit_term_date: "",
                },
            ],
            dialogSelectTitle: false,
            dialogSelectClientInfo: "1",
            doc: {
                doc_no: "",
                doc_type: "fixed",
                status: "Invoiced",
                doc_date_show: "",
                client_code: "",
                client_name: "",
                client_address: "",
                tax_id: "",
                branch: "",
                payment_term: "0",
                currency: "THB",
                vat_percent: "7.00",
                not_to_exceed_cap: "",
                items: [],
                linked_invoices: [],
            },
            clientOptions: [],
        };
    },
    computed: {
        headerEditable() {
            return !this.isLocked; // Draft และ Submitted แก้ header ได้
        },
        statusLabel() {
            return { Invoiced: "Invoiced", InProgress: "In Progress" }[this.doc.status] || this.doc.status;
        },
        statusColor() {
            return { Invoiced: "green", InProgress: "purple" }[this.doc.status] || "grey";
        },
        fixedTotals() {
            let vatBase = 0, noVatBase = 0, vatAmount = 0, vatCount = 0, noVatCount = 0;
            const rate = Number(this.doc.vat_percent) || 0;
            (this.doc.items || []).forEach((r) => {
                const lineTotal = (Number(r.qty) || 0) * (Number(r.price) || 0);
                if (r.applyVat) {
                    vatCount += 1;
                    vatBase += lineTotal;
                    vatAmount += lineTotal * (rate / 100);
                } else {
                    noVatCount += 1;
                    noVatBase += lineTotal;
                }
            });
            const total = vatBase + noVatBase;
            return {
                total, vat: vatAmount, grandTotal: total + vatAmount,
                vatBase, noVatBase, vatCount, noVatCount, rowCount: (this.doc.items || []).length,
            };
        },
        estimateTotals() {
            let vatBase = 0, noVatBase = 0, vatAmount = 0, vatCount = 0, noVatCount = 0;
            const rate = Number(this.doc.vat_percent) || 0;
            (this.doc.items || []).forEach((r) => {
                const lineTotal = Number(r.rate) || 0;
                if (r.applyVat) {
                    vatCount += 1;
                    vatBase += lineTotal;
                    vatAmount += lineTotal * (rate / 100);
                } else {
                    noVatCount += 1;
                    noVatBase += lineTotal;
                }
            });
            const total = vatBase + noVatBase;
            return {
                total, vat: vatAmount, grandTotal: total + vatAmount,
                vatBase, noVatBase, vatCount, noVatCount, rowCount: (this.doc.items || []).length,
            };
        },
        vatDetailRows() {
            const isFixed = this.doc.doc_type === "fixed";
            return (this.doc.items || []).map((row) => {
                const base = isFixed
                    ? (Number(row.qty) || 0) * (Number(row.price) || 0)
                    : (Number(row.rate) || 0);
                const vatAmount = row.applyVat ? base * ((Number(row.vatRate) || 0) / 100) : 0;
                return {
                    name: row.name || "-",
                    base,
                    applyVat: row.applyVat,
                    vatRate: row.vatRate,
                    vatAmount,
                    afterVat: base + vatAmount,
                };
            });
        },
        vatDetailTotals() {
            return this.doc.doc_type === "fixed" ? this.fixedTotals : this.estimateTotals;
        },
        estimateTotal() {
            // row.rate ถูก format เป็น string ผ่าน this.fmt() ตอน map มาแล้วใน loadQuotation()
            // ต้อง strip comma ก่อนแปลงเป็นตัวเลขกัน NaN
            return (this.doc.items || []).reduce((s, r) => {
                const raw = (r.rate || "").toString().replace(/,/g, "");
                return s + (Number(raw) || 0);
            }, 0);
        },
        cumulativeInvoiced() {
            return (this.doc.linked_invoices || []).reduce((s, inv) => s + inv.amount, 0);
        },
        // Note 17: เทียบยอดสะสมกับวงเงินไม่เกิน — แสดงเฉพาะตอนมีการระบุไว้ตอนสร้างเอกสารเท่านั้น
        hasCap() {
            const raw = (this.doc.not_to_exceed_cap || "").toString().replace(/,/g, "").trim();
            return raw !== "" && Number(raw) > 0;
        },
        capAmount() {
            const raw = (this.doc.not_to_exceed_cap || "").toString().replace(/,/g, "").trim();
            return Number(raw) || 0;
        },
        capExceeded() {
            return this.hasCap && this.cumulativeInvoiced > this.capAmount;
        },
    },
    async mounted() {
        try {
            await api.checkVersion();

            this.userId = localStorage.getItem(server.USER_ID);
            this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

            if (this.authorize_id == null || this.authorize_id == 0) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Authorize Failed!!!",
                    "Please Logout And Login Again!!!",
                    "text-h5 red--text text-center"
                );
                this.$router.back();
                return;
            }

            const parser = document.createElement("a");
            parser.href = window.location;
            const routerPath = parser.pathname.split("/")[1];

            const resAuth = await api.getAuthorize(this.userId, routerPath);
            const permission = resAuth.data[0];

            if (!permission) {
                this.$router.back();
                return;
            }

            this.authorize_view = permission.smd_view >= 1;

            if (!this.authorize_view) {
                this.$router.back();
                return;
            }

            if (this.userId && api.isLoggedIn()) {
                // already logged in
            } else {
                this.$store.state.isLogged = false;
                this.$router.push("/login");
                return;
            }
        } catch (error) {
            console.error("QuotationView mounted() auth error:", error);
            this.$store.state.isLogged = false;
            this.$router.push("/login");
            return;
        }

        // ===== โหลดข้อมูลเอกสารจริง แยก catch ออกจาก auth =====
        this.$showLoader();
        try {
            await this.loadCurrency();
            await this.loadCustomer();
            await this.loadQuotation();
            if (this.doc.status == 'Invoiced') {
                await this.loadDataInvoice();
            } else {
                this.linked_invoices = [];
            }
        } catch (error) {
            console.error("QuotationView mounted() load data error:", error);
            await Swal.fire({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                text: "ไม่สามารถโหลดข้อมูลเอกสารได้ กรุณาลองใหม่อีกครั้ง",
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
            });
        } finally {
            this.$hideLoader();
        }
    },
    methods: {
        async loadCurrency() {
            const res_cur = await api.getDataCurrency();
            this.currency_list = res_cur.data;
        },
        getFileName() {
            return `Quotation_${this.doc.doc_no || ((this.docType === "fixed" ? "QT-" : "EST-") + "(ออกอัตโนมัติเมื่อบันทึก)")}.pdf`
        },
        async loadCustomer() {
            const result = await api.getAllCustomerListactiveCompany({
                params: {
                    company_id: localStorage.getItem(server.COMPANYID),
                },
            });
            this.clientOptions = result.data.map((item) => ({
                id: item.id,
                code: item.cust_account,
                name: item.name,
                address: item.address,
                tax_id: item.taxid,
                branch: item.branch,
            }));
        },
        async loadQuotation() {
            const id = this.$route.params.id;

            try {
                const res = await api.billing_expense_getAllQuotationsByID(id);
                const record = res.data;

                if (!record) {
                    await Swal.fire({
                        icon: "error",
                        title: "ไม่พบเอกสาร",
                        text: "ไม่พบเอกสารที่ต้องการดู",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                    });
                    this.$router.push("/quotation-list");
                    return;
                }

                // ✅ แก้บั๊ก type mismatch
                const clientMatch = this.clientOptions.find(
                    (c) => Number(c.id) === Number(record.client_id)
                );

                const items = record.doc_type === "fixed"
                    ? (record.items || []).map((item) => ({
                        id: item.item_row_id,
                        name: item.item_name,
                        detail: item.detail || "",
                        qty: item.qty != null ? Number(item.qty) : 0,
                        unit: item.unit || "",
                        price: item.unit_price != null ? Number(item.unit_price) : 0,
                        applyVat: item.apply_vat != null ? !!item.apply_vat : true,
                    }))
                    : (record.items || []).map((item) => ({
                        id: item.item_row_id,
                        name: item.item_name,
                        detail: item.detail || "",
                        rate: item.line_total != null ? Number(item.line_total) : 0,
                        applyVat: item.apply_vat != null ? !!item.apply_vat : true,
                    }));
                console.log(record)
                this.doc = {
                    doc_no: record.doc_no,
                    doc_type: record.doc_type,
                    status: record.status,
                    doc_date: record.doc_date,
                    doc_date_show: this.formatDocDateShow(record.doc_date),
                    client_code: clientMatch ? clientMatch.code : "",
                    client_name: clientMatch ? clientMatch.name : (record.client ? record.client.name : `Client #${record.client_id}`),
                    client_address: record.client_address,
                    tax_id: clientMatch ? clientMatch.tax_id : "",
                    branch: clientMatch ? clientMatch.branch : "",
                    payment_term: String(record.payment_term ?? "0"),
                    currency: record.currency,
                    vat_percent: String(record.vat_percent ?? "0"),
                    attention: record.attention,
                    contact_position: record.contact_position,
                    po_no: record.po_no,
                    po_date: record.po_date,
                    delivery_date: record.delivery_date,
                    additional_info: record.additional_info,
                    not_to_exceed_cap: record.not_to_exceed_cap != null ? String(record.not_to_exceed_cap) : "",
                    items: items,
                    linked_invoices: [],
                };

            } catch (error) {
                console.error("loadQuotation error:", error);
                await Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: "ไม่สามารถโหลดข้อมูลเอกสารได้",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
                this.$router.push("/quotation-list");
            }
        },
        async loadDataInvoice() {
            const id = this.$route.params.id;
            try {
                const res_inv = await api.billing_expense_loaddata_quottions_invocie(Number(id));
                const invoices = res_inv.data || [];

                this.doc.linked_invoices = invoices.map((inv) => ({
                    id: inv.id,
                    invoice_no: inv.inv_id,
                    date: inv.inv_date,
                    period: inv.billing_period, // ยังไม่มีข้อมูล "รอบบิล" จาก API ตอนนี้ ใส่ placeholder ไว้ก่อน
                    amount: Number(inv.sub_total) || 0,
                    status: inv.inv_status,
                }));
            } catch (error) {
                console.error("loadDataInvoice error:", error);
                this.doc.linked_invoices = [];
            }
        },
        formatDocDateShow(dateOnly) {
            if (!dateOnly) return "";
            const [yyyy, mm, dd] = dateOnly.split("-");
            if (!yyyy || !mm || !dd) return "";
            return `${dd}/${mm}/${yyyy}`;
        },
        getBackList() {
            this.$router.push("/quotation-list");
        },
        fmt(n) {
            return (Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        onViewInvoice(id, inv_status) {
            if (inv_status == "Invoice" || inv_status == "P.invoice") {
                const routeData = this.$router.resolve(`/edit-invoice/${id}/inv_h/edit`);
                window.open(routeData.href, "_blank");
            } else if (inv_status == "Receive") {
                const routeData = this.$router.resolve(`/edit-invoice/${id}/inv_h/edit`);
                window.open(routeData.href, "_blank");
            } else {
                return;
            }
        },
        async onPrint() {
            this.dialogSelectTitle = true;
        },
        async confirmPrint() {
            try {
                // เลือกข้อมูลบริษัทจาก print_header_list ตาม id ที่เลือกในไดอะล็อก
                // (fallback เป็นตัวแรกถ้าหาไม่เจอ กัน dialogSelectClientInfo ค้างค่าผิด)
                const selectedCompany =
                    this.print_header_list.find((c) => c.id === this.dialogSelectClientInfo) ||
                    this.print_header_list[0];

                const header = {
                    company_inv: "L", // ใช้ "L" เสมอเพราะเรากำหนด com_eng_1/com_thai/com_add_* เองครบแล้ว
                    com_eng_1: selectedCompany.com_eng_1,
                    com_eng_2: selectedCompany.com_eng_2,
                    com_thai: selectedCompany.com_thai,
                    com_add_name: selectedCompany.com_add_name,
                    com_add_no: selectedCompany.com_add_no,
                    com_add_city: selectedCompany.com_add_city,
                    com_add_country: selectedCompany.com_add_country,
                    com_add_tel: selectedCompany.com_add_tel,
                    com_add_email: selectedCompany.com_add_email,
                    com_add_tax_id: selectedCompany.com_add_tax_id,
                    // ✅ เพิ่ม: ใช้แทรกในข้อความ Quotation Terms เริ่มต้น ให้ตรงกับบริษัทที่เลือกจริง
                    company_display_name: selectedCompany.com_display_name,
                    doc_no: this.doc.doc_no,
                    doc_date: this.doc.doc_date,
                    doc_type: this.doc.doc_type,
                    customer_name: this.doc.client_name,
                    customer_address: this.doc.client_address,
                    customer_taxid: this.doc.tax_id,
                    attention: this.doc.attention,
                    payment_term: this.doc.payment_term,
                    currency: this.doc.currency,
                    subtotal: this.doc.doc_type === "fixed" ? this.fixedTotals.total : this.estimateTotals.total,
                    vat_percent: this.doc.vat_percent,
                    vat_base: this.doc.doc_type === "fixed" ? this.fixedTotals.vatBase : this.estimateTotals.vatBase,
                    no_vat_base: this.doc.doc_type === "fixed" ? this.fixedTotals.noVatBase : this.estimateTotals.noVatBase,
                    vat_amount: this.doc.doc_type === "fixed" ? this.fixedTotals.vat : this.estimateTotals.vat,
                    grand_total: this.doc.doc_type === "fixed" ? this.fixedTotals.grandTotal : this.estimateTotals.grandTotal,
                    amount_in_words: "",
                    not_to_exceed_cap: this.doc.not_to_exceed_cap,
                    additional_info: this.doc.additional_info,
                };

                const items = this.doc.items.map((row) => ({
                    description: row.name,
                    detail: row.detail,
                    apply_vat: !!row.applyVat,
                    amount: this.doc.doc_type === "fixed" ? (row.qty || 0) * (row.price || 0) : undefined,
                    rate: this.doc.doc_type === "estimate" ? row.rate : undefined,
                }));

                //ฟังก์ชันปริ้นเก่า
                // await pdfQuotationGenerator.exportToPDF({ header, items });

                //ฟังก์ชันปริ้นใหม่
                const blob = await pdfQuotationGenerator.exportToPDF({ header, items });
                this.pdfBlob = blob;
                this.dialogSelectTitle = false;
                this.dialogPDF = true;
                this.dialogSelectTitle = false;
            } catch (error) {
                this.dialogSelectTitle = false;
                console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
                alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
            }
        },


    },
    async beforeCreate() {
        this.$store.state.navMenu = true;
    },

};
